import { every } from 'lodash';
import { AppService } from '@app/app.service';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import * as R from 'ramda';
import Publication from '@app/publication';

@Component({
  selector: 'app-list[class="page-content"]',
  templateUrl: './list.component.html',
  styleUrls: ['./list.component.less']
})
export class ListComponent implements OnInit {
  @ViewChild('hubsDropdownButton') public hubsDropdownButtonRef: ElementRef;
  publications: Publication[];
  isHubsDropdownShown = false;

  allSources(publication) {
    return R.flatten(R.map(R.path(['sources']), publication.sections));
  }

  allSourcesCount(publication) {
    return R.sum(R.map(R.compose(R.length, R.path(['sources'])), publication.sections));
  }

  constructor(
    private appService: AppService,
  ) { }

  ngOnInit() {
    this.appService
      .getPublications()
      .subscribe((data: {publications: Publication[]}) => { this.publications = data.publications; });

    window.addEventListener('click', (event: MouseEvent & {path: Array<{}>}) => {
      if (every(event.path, node => this.hubsDropdownButtonRef.nativeElement !== node)) {
        this.isHubsDropdownShown = false;
      }
    });
  }

  toggleHubsDropdown() {
    this.isHubsDropdownShown = !this.isHubsDropdownShown;
  }
}



// WEBPACK FOOTER //
// /Users/nide/Code/3dissue/3d-issue-hubs-ui/src/app/list/list.component.ts